import 'lazysizes';

const isSP = () => window.innerWidth < 768;
const getMapUrl = () => require(`images/areamap/map_${isSP() ? 'sp' : 'pc'}.jpg`);
const getPinUrl = region => require(`images/areamap/btn_mappin_${region}_${isSP() ? 'sp' : 'pc'}.png`);

function observeElements() {
  document
    .querySelectorAll('.bg[data-bg-target="true"]')
    .forEach(el => {
      el.dataset.bg = getMapUrl();
    });

  document
    .querySelectorAll('.region__link[data-bg="true"]')
    .forEach(el => {
      el.dataset.bg = getPinUrl(el.dataset.region);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeElements);
} else {
  observeElements();
}

document.addEventListener('lazybeforeunveil', e => {
  const bg = e.target.dataset.bg;
  if (bg) {
    e.target.style.backgroundImage = `url(${bg})`;
  }
});
